module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAABE0lEQVR4AUyOMU8CQRCF3wx7Z6OVRlrp7P0fWoiFih0xhLvkDsRGLTZBbdR4l2hCDJ1EGzHhh9hb2pJoZ8PdceMsldPs2/1m33vc7trLoGvvw/Cihn8Thv1au2OToGP7DMGysp3SN+1Wz66rRjO6qopXBETYFmCFS0ECkXcC9iqC6PjEbvqcxyCq68LYcR4k9mtW+jckeFXXQyMYqcM+gJdsnt0OlLNeMEzPp3mBZ3X8UcctffsucoyG6fVUNRZLroNncKQRqxrxoWDNeGg0o7OqanArthtLnJ0KYRFREBriooEDv+L3HGcmxPp7V6PeZnMvfbqzn1npJShlrB3rjjMIvwBNKDePrht03EmFeVA5cfwPAAD//+HX0xoAAAAGSURBVAMA7/1uod/ND9QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tag_close.png
// module id = 7ux7
// module chunks = 2